import { render, staticRenderFns } from "./videoShow.vue?vue&type=template&id=4e8356ad&scoped=true"
import script from "./videoShow.vue?vue&type=script&lang=js"
export * from "./videoShow.vue?vue&type=script&lang=js"
import style0 from "./videoShow.vue?vue&type=style&index=0&id=4e8356ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8356ad",
  null
  
)

export default component.exports